/**************************************************
 * Nombre:       Tarjeta_Anuncios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {WhatsApp} from "@mui/icons-material";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {irUrl} from "../../Utilidades/irUrl";

const Tarjeta_Anuncios = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: sCell ? 'center' : 'left'}}>
                <Typography sx={{
                    color: '#fff',
                    fontSize: sCell ? 40 : 48,
                    lineHeight: 1.1,
                    textAlign: sCell ?  'center' : 'left',
                    fontWeight: 800
                }}>{item.nombre}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{mt: 1, justifyContent: sCell ? 'center' : 'left'}}>
                <Typography sx={{
                    color: '#fff',
                    fontSize: 20,
                    fontWeight: 400,
                    lineHeight: 1.1,
                    textAlign: sCell ?  'center' : 'left'
                }}>{item.descripcion}</Typography>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{mt: 3, mb: sCell ? 3 : 26, justifyContent: sCell ? 'center' : 'left'}}>
                <Button
                     onClick={() => irUrl(item.link)}


                >Mas Información</Button>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Anuncios